import script from "./HMA.vue?vue&type=script&lang=js"
export * from "./HMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__